// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1_goX","col":"Table_col__1hFIC","fulfillmentStatus":"Table_fulfillmentStatus__iHnFG","emailCol":"Table_emailCol__3lsCZ"};